import { call, put, all, takeEvery } from "redux-saga/effects";
import { generalActions } from "../actions";
import api from "../services/general.service";
import ACTIONS from "../constants";

function* getDashboardSummary() {
  try {
    yield put(generalActions.getDashboardSummaryAttempt.pending);
    const dashboard = yield call(api.dashboardSummaryRequest);
    yield put(generalActions.getDashboardSummaryAttempt.success(dashboard));
  } catch (error) {
    yield put(generalActions.getDashboardSummaryAttempt.error(error.message));
  }
}

function* getSettings() {
  try {
    yield put(generalActions.updateAccountSettingsAttempt.pending);
    const settings = yield call(api.settingsRequest);
    if (settings)
      yield localStorage.setItem("settings", JSON.stringify(settings));
    yield put(generalActions.updateAccountSettingsAttempt.success(settings));
  } catch (error) {
    yield put(generalActions.updateAccountSettingsAttempt.error(error.message));
  }
}

function* updateSettings(state) {
  try {
    yield put(generalActions.updateAccountSettingsAttempt.pending);
    yield call(api.updateSettingsRequest, state.payload);
    const settings = yield call(api.settingsRequest);
    if (settings)
      yield localStorage.setItem("settings", JSON.stringify(settings));
    yield put(generalActions.updateAccountSettingsAttempt.success(settings));
    yield put(
      generalActions.showToast({
        title: "Account settings saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    const errArr = [];
    for (const key in errorObject) {
      if (Object.hasOwnProperty.call(errorObject, key)) {
        const errorMessages = errorObject[key];
        errorMessages.forEach((errorMessage) => {
          errArr.push(errorMessage);
        });
      }
    }

    // for(let i = 0; i < errArr.length; i++) {
    //   yield put(
    //     generalActions.showToast({
    //       title: errArr[i],
    //       type: 'error',
    //     }),
    //   );
    // }

    yield put(
      generalActions.showToast({
        title: errArr[0],
        type: "error",
      })
    );
    yield put(generalActions.updateAccountSettingsAttempt.error(error.message));
  }
}

function* updateLogo(state) {
  try {
    yield put(generalActions.updateLogoAttempt.pending);
    yield call(api.updateLogoRequest, state.payload);
    const settings = yield call(api.settingsRequest);
    if (settings)
      yield localStorage.setItem("settings", JSON.stringify(settings));
    yield put(generalActions.updateLogoAttempt.success(settings));
    yield put(
      generalActions.showToast({
        title: "Account logo saved",
        type: "success",
      })
    );
  } catch (error) {
    yield put(generalActions.updateLogoAttempt.error(error.message));
  }
}

function* getNotifications() {
  try {
    yield put(generalActions.getNotificationsAttempt.pending);
    const notifications = yield call(api.getNotificationsRequest);
    yield put(generalActions.getNotificationsAttempt.success(notifications));
  } catch (error) {
    yield put(generalActions.getNotificationsAttempt.error(error.message));
  }
}

function* deleteNotification(state) {
  try {
    yield put(generalActions.deleteNotificationAttempt.pending);
    yield call(api.deleteNotificationRequest, state.payload);
    const notifications = yield call(api.getNotificationsRequest);
    yield put(generalActions.deleteNotificationAttempt.success(notifications));
  } catch (error) {
    yield put(generalActions.deleteNotificationAttempt.error(error.message));
  }
}

function* markNotificationRead(state) {
  try {
    yield put(generalActions.markNotificationReadAttempt.pending);
    yield call(api.markNotificationReadRequest, state.payload);
    const notifications = yield call(api.getNotificationsRequest);
    yield put(generalActions.markNotificationReadAttempt.success(notifications));
  } catch (error) {
    yield put(generalActions.markNotificationReadAttempt.error(error.message));
  }
}

function* createReminder(state) {
  try {
    yield put(generalActions.createReminderAttempt.pending);
    yield call(api.createRemindersRequest, state.payload);
    yield put(
      generalActions.showToast({
        title: "Reminder created",
        type: "success",
      })
    );
    const receivedReminders = yield call(api.getRemindersRequest);
    let onlyMeReminders = yield call(api.getRemindersRequest, {
      query: "onlyMine",
    });
    onlyMeReminders = onlyMeReminders.map((reminder) => {
      return { ...reminder, onlyMine: true };
    });
    yield put(
      generalActions.createReminderAttempt.success({reminders: receivedReminders, createdReminders: onlyMeReminders })
    );
  } catch (error) {
    yield put(generalActions.createReminderAttempt.error(error.message));
  }
}

function* updateReminder(state) {
  try {
    yield put(generalActions.updateReminderAttempt.pending);
    yield call(api.updateRemindersRequest, state.payload);
    const receivedReminders = yield call(api.getRemindersRequest);
    let onlyMeReminders = yield call(api.getRemindersRequest, {
      query: "onlyMine",
    });
    onlyMeReminders = onlyMeReminders.map((reminder) => {
      return { ...reminder, onlyMine: true };
    });
    yield put(
      generalActions.updateReminderAttempt.success({reminders: receivedReminders, createdReminders: onlyMeReminders })
    );
    yield put(
      generalActions.showToast({
        title: "Reminder updated!",
        type: "success",
      })
    );
  } catch (error) {
    yield put(generalActions.updateReminderAttempt.error(error.message));
  }
}

function* getReminders() {
  try {
    yield put(generalActions.getRemindersAttempt.pending);
    const receivedReminders = yield call(api.getRemindersRequest);
    let onlyMeReminders = yield call(api.getRemindersRequest, {
      query: "onlyMine",
    });
    onlyMeReminders = onlyMeReminders.map((reminder) => {
      return { ...reminder, onlyMine: true };
    });
    yield put(
      generalActions.getRemindersAttempt.success({reminders: receivedReminders, createdReminders: onlyMeReminders })
    );
  } catch (error) {
    yield put(generalActions.getRemindersAttempt.error(error.message));
  }
}

function* fetchReminder(state) {
  try {
    yield put(generalActions.fetchReminderAttempt.pending);
    const id = state.payload;
    const reminder = yield call(api.getReminderDetailRequest, state.payload);
    reminder.id = id;
    yield put(generalActions.fetchReminderAttempt.success(reminder));
  } catch (error) {
    yield put(generalActions.fetchReminderAttempt.error(error.message));
  }
}

function* deleteReminder(state) {
  try {
    yield put(generalActions.deleteReminderAttempt.pending);
    yield call(api.deleteReminderRequest, state.payload);
    const receivedReminders = yield call(api.getRemindersRequest);
    let onlyMeReminders = yield call(api.getRemindersRequest, {
      query: "onlyMine",
    });
    onlyMeReminders = onlyMeReminders.map((reminder) => {
      return { ...reminder, onlyMine: true };
    });
    yield put(
      generalActions.deleteReminderAttempt.success({reminders: receivedReminders, createdReminders: onlyMeReminders })
    );
  } catch (error) {
    yield put(generalActions.deleteReminderAttempt.error(error.message));
  }
}

function* markReminderRead(state) {
  try {
    yield put(generalActions.markReminderReadAttempt.pending);
    yield call(api.markReminderReadRequest, state.payload);
    const receivedReminders = yield call(api.getRemindersRequest);
    let onlyMeReminders = yield call(api.getRemindersRequest, {
      query: "onlyMine",
    });
    onlyMeReminders = onlyMeReminders.map((reminder) => {
      return { ...reminder, onlyMine: true };
    });
    yield put(
      generalActions.markReminderReadAttempt.success({reminders: receivedReminders, createdReminders: onlyMeReminders })
    );
  } catch (error) {
    yield put(generalActions.markReminderReadAttempt.error(error.message));
  }
}

function* reminderSnooze(state) {
  try {
    yield put(generalActions.setReminderSnoozeAttempt.pending);
    yield call(api.reminderSnoozeRequest, state.payload.payload);
    const receivedReminders = yield call(api.getRemindersRequest);
    let onlyMeReminders = yield call(api.getRemindersRequest, {
      query: "onlyMine",
    });
    onlyMeReminders = onlyMeReminders.map((reminder) => {
      return { ...reminder, onlyMine: true };
    });
    yield put(
      generalActions.setReminderSnoozeAttempt.success({reminders: receivedReminders, createdReminders: onlyMeReminders })
    );
  } catch (error) {
    yield put(generalActions.setReminderSnoozeAttempt.error(error.message));
  }
}

function* getPJMDashboardSummary() {
  try {
    yield put(generalActions.getPJMDashboardSummaryAttempt.pending);
    const dashboard = yield call(api.pjmDashboardSummaryRequest);
    yield put(generalActions.getPJMDashboardSummaryAttempt.success(dashboard));
  } catch (error) {
    yield put(generalActions.getPJMDashboardSummaryAttempt.error(error.message));
  }
}

function* getPJMDashboardDetail(action) {
  try {
    yield put(generalActions.getPJMDashboardDetailAttempt.pending);
    const detail = yield call(api.pjmDashboardDetailRequest, action.projectId);
    yield put(generalActions.getPJMDashboardDetailAttempt.success(detail));
  } catch (error) {
    yield put(generalActions.getPJMDashboardDetailAttempt.error(error.message));
  }
}

function* getPRMDashboardSummary() {
  try {
    yield put(generalActions.getPRMDashboardSummaryAttempt.pending);
    const dashboard = yield call(api.prmDashboardSummaryRequest);
    yield put(generalActions.getPRMDashboardSummaryAttempt.success(dashboard));
  } catch (error) {
    yield put(generalActions.getPRMDashboardSummaryAttempt.error(error.message));
  }
}

function* getPRMDashboardDetail(action) {
  try {
    yield put(generalActions.getPRMDashboardDetailAttempt.pending);
    const detail = yield call(api.prmDashboardDetailRequest, action.programId);
    yield put(generalActions.getPRMDashboardDetailAttempt.success(detail));
  } catch (error) {
    yield put(generalActions.getPRMDashboardDetailAttempt.error(error.message));
  }
}

function* getPOMDashboardSummary(action) {
  try {
    yield put(generalActions.getPOMDashboardSummaryAttempt.pending);
    const dashboard = yield call(api.pomDashboardSummaryRequest, action.filters);
    yield put(generalActions.getPOMDashboardSummaryAttempt.success(dashboard));
  } catch (error) {
    yield put(generalActions.getPOMDashboardSummaryAttempt.error(error.message));
    yield put(generalActions.showToast({ title: "Something went wrong loading the dashboard. Please try again.", type: "error" }));
  }
}

function* getPOMDashboardDetail(action) {
  try {
    yield put(generalActions.getPOMDashboardDetailAttempt.pending);
    const detail = yield call(api.pomDashboardDetailRequest, action.portfolioId, action.filters);
    yield put(generalActions.getPOMDashboardDetailAttempt.success(detail));
  } catch (error) {
    yield put(generalActions.getPOMDashboardDetailAttempt.error(error.message));
    yield put(generalActions.showToast({ title: "Something went wrong loading the portfolio data. Please try again.", type: "error" }));
  }
}

function* getPOMDashboardGrouped(action) {
  try {
    yield put(generalActions.getPOMDashboardGroupedAttempt.pending);
    const groups = yield call(api.pomDashboardGroupedRequest, action.filters, action.portfolioId);
    yield put(generalActions.getPOMDashboardGroupedAttempt.success(groups));
  } catch (error) {
    yield put(generalActions.getPOMDashboardGroupedAttempt.error(error.message));
    yield put(generalActions.showToast({ title: "Something went wrong loading the grouped dashboard data. Please try again.", type: "error" }));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.DASHBOARD_SUMMARY_CALL, getDashboardSummary),
    takeEvery(ACTIONS.ACCOUNT_SETTINGS_CALL, getSettings),
    takeEvery(ACTIONS.UPDATE_ACCOUNT_SETTINGS_CALL, updateSettings),
    takeEvery(ACTIONS.UPDATE_ACCOUNT_LOGO_CALL, updateLogo),
    takeEvery(ACTIONS.DELETE_NOTIFICATION_CALL, deleteNotification),
    takeEvery(ACTIONS.GET_NOTIFICATIONS_CALL, getNotifications),
    takeEvery(ACTIONS.MARK_NOTIFICATION_READ_CALL, markNotificationRead),
    takeEvery(ACTIONS.FETCH_REMINDER_CALL, fetchReminder),
    takeEvery(ACTIONS.DELETE_REMINDER_CALL, deleteReminder),
    takeEvery(ACTIONS.CREATE_REMINDER_CALL, createReminder),
    takeEvery(ACTIONS.UPDATE_REMINDER_CALL, updateReminder),
    takeEvery(ACTIONS.GET_REMINDERS_CALL, getReminders),
    takeEvery(ACTIONS.MARK_REMINDER_READ_CALL, markReminderRead),
    takeEvery(ACTIONS.REMINDER_SNOOZE_CALL, reminderSnooze),
    takeEvery(ACTIONS.PJM_DASHBOARD_SUMMARY_CALL, getPJMDashboardSummary),
    takeEvery(ACTIONS.PJM_DASHBOARD_DETAIL_CALL, getPJMDashboardDetail),
    takeEvery(ACTIONS.PRM_DASHBOARD_SUMMARY_CALL, getPRMDashboardSummary),
    takeEvery(ACTIONS.PRM_DASHBOARD_DETAIL_CALL, getPRMDashboardDetail),
    takeEvery(ACTIONS.POM_DASHBOARD_SUMMARY_CALL, getPOMDashboardSummary),
    takeEvery(ACTIONS.POM_DASHBOARD_DETAIL_CALL, getPOMDashboardDetail),
    takeEvery(ACTIONS.POM_DASHBOARD_GROUPED_CALL, getPOMDashboardGrouped),
  ]);
}
